import ShoeHeading from "./ShoeHeading.component";

export default ShoeHeading;
